import React from 'react';
import { Card, Avatar, Button } from 'antd';
import {
    MailOutlined,
    PhoneOutlined,
    CalendarOutlined,
} from '@ant-design/icons';
import { cn } from '../../../../utils/cn';
import { getInitials } from '../../../../utils/helper';

const EnhancedLeadsImportedViaFormCardView = ({
    record,
    onCardClick,
    actions = []
}) => {
    const initials = getInitials(record.name);
    return (
        <Card
            hoverable
            className="h-full relative"
            onClick={() => onCardClick && onCardClick(record)}
        >
            <div className="space-y-3 sm:space-y-4">
                {/* Header */}
                <div className="flex items-start justify-between">
                    <div className="flex items-center space-x-2 sm:space-x-3 overflow-hidden">
                        <Avatar
                            size={40}
                            className={cn("flex-shrink-0 font-semibold text-base sm:text-lg sm:w-12 sm:h-12", record.originalData?.photo ? "" : "!bg-primary")}
                            src={record.originalData?.photo ?? ""}
                        >
                            {initials}
                        </Avatar>
                        <div className="min-w-0 flex-1">
                            <h3 className="font-semibold text-sm sm:text-base mb-1 truncate" title={record.name}>
                                {record.name || "N/A"}
                            </h3>
                            {record.eventName && (
                                <p className="text-gray-500 text-xs sm:text-sm mb-0 truncate" title={record.eventName}>
                                    Event: {record.eventName}
                                </p>
                            )}
                        </div>
                    </div>
                </div>

                {/* Contact Info */}
                <div className="space-y-1.5 sm:space-y-2 border-b border-gray-200 pb-2 sm:pb-3">
                    <div className="flex items-center text-xs sm:text-sm text-gray-600">
                        <MailOutlined className="mr-2 flex-shrink-0" />
                        <span className="truncate" title={record.email ?? "user-email"}>{record.email ?? "-"}</span>
                    </div>
                    <div className="flex items-center text-xs sm:text-sm text-gray-600">
                        <PhoneOutlined className="mr-2 flex-shrink-0" />
                        <span className="truncate" title={record.phone ?? "user-phone"}>{record.phone ?? "-"}</span>
                    </div>
                </div>

                {/* Event Details Section */}
                <div className="space-y-2 sm:space-y-3">
                    {/* Event Name */}
                    <div className="flex items-center justify-between">
                        <span className="text-xs sm:text-sm text-gray-600 font-medium">
                            Event:
                        </span>
                        <span className="text-xs sm:text-sm text-gray-700 truncate max-w-[60%]" title={record.eventName}>
                            {record.eventName ?? "-"}
                        </span>
                    </div>


                    {/* Imported At */}
                    <div className="flex items-center justify-between pt-1">
                        <span className="text-xs sm:text-sm text-gray-600 font-medium">
                            <CalendarOutlined className="mr-1" />
                            Imported At:
                        </span>
                        <span className="text-xs sm:text-sm text-gray-700">
                            {record.importedAt}
                        </span>
                    </div>
                </div>
                {/* Action Buttons */}
                <div
                    className={cn(
                        "grid gap-1.5 sm:gap-2 pt-2 sm:pt-3 border-t border-gray-200 mt-2",
                        actions.length === 1 ? "flex justify-end" : "xs:grid-cols-2 grid-cols-1"
                    )}
                >
                    {actions.map((action, idx) => (
                        <Button
                            key={idx}
                            title={action.title ?? action.label}
                            className={cn(
                                "text-xs sm:text-sm font-medium h-8 sm:h-9 my-0.5 sm:my-1 !min-w-full flex justify-center items-center transition-colors duration-150 ease-in-out",
                                action.className,
                                actions.length === 1 && "!w-1/2"
                            )}
                            onClick={(e) => {
                                e.stopPropagation();
                                action.onClick(record);
                            }}
                        >
                            {action.icon &&
                                React.cloneElement(action.icon, { className: "mr-2" })}
                            {action.label}
                        </Button>
                    ))}
                </div>
            </div>
        </Card>
    );
};

export default EnhancedLeadsImportedViaFormCardView;
